import { render, staticRenderFns } from "./HrAssetDiscountList.vue?vue&type=template&id=2beb997e&lang=pug&"
import script from "./HrAssetDiscountList.vue?vue&type=script&lang=js&"
export * from "./HrAssetDiscountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrAssetDiscountList.vue"
export default component.exports